(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/filter', '../util/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/filter'), require('../util/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.filter, global.convert);
    global.filter = mod.exports;
  }
})(this, function (exports, _filter2, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.filter = undefined;

  var _filter3 = _interopRequireDefault(_filter2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Replaces by an array of elements <code>predicate</code> returns truthy for.
   * @function
   * @memberof collection
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {function} [predicate={@link https://lodash.com/docs#identity|lodash.identity}] The function invoked per iteration.
   * @return {Object} Returns the updated object.
   * @see {@link https://lodash.com/docs#filter|lodash.filter} for more information.
   * @example filter({ nested: { prop: [1, 2, 3, 4] } }, 'nested.prop', v => v % 2) // => { nested: { prop: [1, 3] } }
   * @since 0.3.0
   */
  var filter = (0, _convert.convert)(_filter3.default);
  exports.filter = filter;
  exports.default = filter;
});